import { Box, TextField } from "@mui/material";
import { ADDRESS_FIELDS } from "./ticketFormConfig";

// The address fields inside the "עדכון כתובת האתר" dialog
const AddressChangeFields = ({ addressChangeRequest, addressFieldErrors, handleAddressFieldChange }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
    {ADDRESS_FIELDS.map(({ key, label, isNumeric, required }, index) => (
      <TextField
        key={key}
        autoFocus={index === 0}
        required={required}
        fullWidth
        label={label}
        value={addressChangeRequest[key]}
        onChange={handleAddressFieldChange(key, label, isNumeric)}
        inputProps={isNumeric ? { inputMode: "numeric" } : undefined}
        error={!!addressFieldErrors[key]}
        helperText={addressFieldErrors[key]}
        variant="outlined"
      />
    ))}
  </Box>
);

export default AddressChangeFields;
